import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const VEHICLE_RENEWAL_TYPE_API = "/vehicleRenewalType";

// ----------------------- STATE ------------------------- //
const state = {
  vehicle_renewal_type_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getVehicle_renewal_type: state =>
    getField(state.vehicle_renewal_type_data[state.currentIndex]),

  getCurrentVehicle_renewal_type: state => {
    return state.vehicle_renewal_type_data[state.currentIndex];
  },

    getVehicle_renewal_type_by_id: state => typeID => {
        return state.vehicle_renewal_type_data.find((item) => item.id === typeID);
    },
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateVehicle_renewal_type(state, payload) {
    updateField(state.vehicle_renewal_type_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.vehicle_renewal_type_data.findIndex(
      vehicle_renewal_type => vehicle_renewal_type.id == theID
    );
  },

  loadAllVehicle_renewal_types(state, payload) {
    state.vehicle_renewal_type_data = payload.data;
    state.currentIndex = 0;
  },

  addVehicle_renewal_type(state, payload) {
    state.vehicle_renewal_type_data.push(payload.data);
    state.currentIndex = state.vehicle_renewal_type_data.length - 1;
  },

  saveVehicle_renewal_type(state, payload) {
    state.vehicle_renewal_type_data[state.currentIndex] = payload.data;
  },

  fetchVehicle_renewal_type(state, payload) {
    if (state.currentIndex == -1) {
      state.vehicle_renewal_type_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.vehicle_renewal_type_data[state.currentIndex] = payload.data;
    }
  },

  deleteVehicle_renewal_type(state, payload) {
    state.currentIndex = state.vehicle_renewal_type_data.findIndex(
      vehicle_renewal_type => vehicle_renewal_type.id == payload.data.id
    );
    state.vehicle_renewal_type_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.vehicle_renewal_type_data = []
    state.currentIndex = -1
  }

};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllVehicle_renewal_types({ commit }) {
    try {
      commit(
        "loadAllVehicle_renewal_types",
        await Repository.get(`${VEHICLE_RENEWAL_TYPE_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addVehicle_renewal_type({ commit }) {
    await Repository.get(`${VEHICLE_RENEWAL_TYPE_API}/new`)
      .then(response => {
        commit("addVehicle_renewal_type", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveVehicle_renewal_type({ state, commit }) {
    try {
      commit(
        "saveVehicle_renewal_type",
        await Repository.post(
          `${VEHICLE_RENEWAL_TYPE_API}`,
          state.vehicle_renewal_type_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchVehicle_renewal_type({ commit }, payloadID) {
    try {
      commit(
        "fetchVehicle_renewal_type",
        await Repository.get(`${VEHICLE_RENEWAL_TYPE_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteVehicle_renewal_type({ commit }, payloadID) {
    try {
      commit(
        "deleteVehicle_renewal_type",
        await Repository.delete(`${VEHICLE_RENEWAL_TYPE_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchVehicle_renewal_types({ commit }, searchTerm) {
    try {
      commit(
        "loadAllVehicle_renewal_types",
        await Repository.get(
          `${VEHICLE_RENEWAL_TYPE_API}/search?q=${searchTerm}`
        )
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
